import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Install immediate error handlers to prevent refresh cycles on admin dashboard
if (window.location.pathname.includes('/admin-dashboard')) {
  // Set global flags to indicate we're in admin dashboard
  window.IS_ADMIN_DASHBOARD = true;
  
  // Install an early error handler
  window.addEventListener('error', (e) => {
    // If it's a script error or map error, prevent it from propagating
    if (e.message === 'Script error.' || 
        !e.filename || 
        (e.message && (e.message.includes('google') || e.message.includes('maps')))) {
      console.log('Early handler: Suppressed error:', e.message);
      e.stopPropagation();
      e.preventDefault();
      return true;
    }
  }, true);
  
  // Create a special flag to ensure we only initialize maps once
  if (!window.mapsInitializationHandled) {
    window.mapsInitializationHandled = true;
    
    // Create a mock for Google Maps to prevent loading issues
    window.google = window.google || {
      maps: {
        // Minimal API surface to prevent errors
        Marker: function() {},
        Map: function() {},
        LatLng: function(lat, lng) { return { lat: () => lat, lng: () => lng }; },
        event: { addListener: function() {} }
      }
    };
  }
}

// Admin dashboard error handling
const setupAdminErrorHandling = () => {
  if (window.location.pathname.includes('/admin-dashboard')) {
    console.log('Admin dashboard detected - disabling error overlay');
    
    // Disable React error overlay
    if (typeof window.__REACT_ERROR_OVERLAY__ !== 'undefined') {
      window.__REACT_ERROR_OVERLAY__.handleRuntimeError = () => {};
      window.__REACT_ERROR_OVERLAY__.startReportingRuntimeErrors = () => {};
      window.__REACT_ERROR_OVERLAY__.dismissRuntimeErrors = () => {};
    }
    
    // Global hooks for error overlay
    window.__REACT_ERROR_OVERLAY_ENTRY_FIRST_RENDER__ = true;
    window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = {
      commands: {},
      listeners: [],
      registerListener: () => {},
      registerCommand: () => {}
    };
    
    // Error suppression
    const errorHandler = (e) => {
      e.stopPropagation();
      e.preventDefault();
      return true;
    };
    
    window.addEventListener('error', errorHandler, true);
    
    // Console error suppression
    const originalConsoleError = console.error;
    console.error = function() {
      if (arguments[0] && typeof arguments[0] === 'string' && 
         (arguments[0].includes('React will try to recreate this component tree') ||
          arguments[0].includes('Script error') ||
          arguments[0].includes('Maps'))) {
        return; // Suppress these errors
      }
      return originalConsoleError.apply(this, arguments);
    };
    
    // Promise rejection handling
    window.addEventListener('unhandledrejection', event => {
      console.log('Suppressing unhandled rejection:', event.reason);
      event.preventDefault();
    });
  }
};

// Run setup immediately
setupAdminErrorHandling();

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Report web vitals if needed
reportWebVitals(); 